<template>
	<div>
		<v-card class="mx-auto elevation-12" style="max-width: 500px">
			<v-card-title class="headline font-weight-black justify-center mb-4">Accept Invite</v-card-title>

			<v-card-subtitle class="text-center">Sign-up or sign-in below to accept the invite from the company</v-card-subtitle>

			<div class="pa-4 pt-4">
				<v-row>
					<v-col class="sx-6">
						<v-btn block depressed :color="isSignUp ? 'primary' : 'grey--lighten-2'" :outlined="isSignUp ? false : true" large @click="goToAuthType('SIGN_UP')"
							>Sign Up</v-btn
						>
						<div class="text-center caption font-weight-bold mt-2">I do not have a Locumbase company account.</div>
					</v-col>
					<v-col class="sx-6">
						<v-btn
							v-model="isSignIn"
							block
							depressed
							:color="isSignIn ? 'primary' : 'grey--lighten-2'"
							:outlined="isSignIn ? false : true"
							large
							@click="goToAuthType('SIGN_IN')"
							>Sign In</v-btn
						>
						<div class="text-center caption font-weight-bold mt-2">I already have a Locumbase company account.</div>
					</v-col>
				</v-row>
			</div>

			<router-view></router-view>
		</v-card>
	</div>
</template>

<script>
export default {
	name: 'UserTypeForm',
	computed: {
		isSignUp() {
			return this.$route.name === 'CompanyAcceptInviteSignUp';
		},

		isSignIn() {
			return this.$route.name === 'CompanyAcceptInviteSignIn';
		},
	},

	methods: {
		goToAuthType(type) {
			let url = '';
			if (type === 'SIGN_IN') {
				url = '/company/invite/accept/sign-in';
			} else if (type === 'SIGN_UP') {
				url = '/company/invite/accept/sign-up';
			}

			this.$router.push({
				path: url,
				query: {
					token: this.$route.query.token,
				},
			});
		},
	},
};
</script>
